// extracted by mini-css-extract-plugin
export default {"message_content":"styles_message_content__Zx388","message_link_container":"styles_message_link_container__zB8rp"};